import React from "react";

import { useTranslation } from "react-i18next";
import { FolderIcon } from "@common/folderIcon";
import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectStatus({ status, isSelected, select, unSelect }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.project} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <FolderIcon className={styles.icon} style={{ fill: status.color }} />
      <p className={styles.name}>
        {t(`projectStatuses.${status.label}`, status.label)}
      </p>
    </div>
  );
}

export { ProjectStatus };
